import { render, staticRenderFns } from "./CourseFlipper.vue?vue&type=template&id=732e19db"
import script from "./CourseFlipper.vue?vue&type=script&lang=js"
export * from "./CourseFlipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports